// src/pages/CourseTime/components/slides/SlideRenderer.comp.jsx
import React from 'react';
import JournalingActivity from '../activities/JournalingActivity.comp';
import ShareWorkActivity from '../activities/ShareWorkActivity.comp';
import PollActivity from '../activities/PollActivity.comp';
import DiscussionActivity from '../activities/DiscussionActivity.comp';
import AssessmentSlide from './AssessmentSlide.comp';
import slideRegistry from './slideRegistry';
import DefaultFallbackSlide from './layouts/DefaultFallbackSlide.comp';
import '../../../../assets/css/glossaryTerm.css';


const SlideRenderer = ({
  slide,
  // Activity props
  journalingText,
  setJournalingText,
  shareWorkLink,
  setShareWorkLink,
  selectedPollOption,
  selectedPollOptions,
  setSelectedPollOption,
  setSelectedPollOptions,
  activityCompleted,
  interactionLoading,
  fetchingExistingRecord,
  inputsDisabled,
  onJournalingSave,
  onShareWorkSubmit,
  onPollSubmit,
  onAssessmentSubmit,
  onDiscussionStart,
  onEditActivity,
  assessmentAnswers,
  setAssessmentAnswers,
  // Additional props for poll results
  module_code,
  session,
  segment,
  slideIndex,
  questionNumber,
  totalQuestions,
  collapsed,
  renderSpokenText,
  skipTitleSpeech,
  assessmentScore,
  assessmentResultLoading,
  themeColor,
  pageLc,
  // Assessment intro CTA (replaces the floating nav arrow + top progress bar,
  // both hidden for this slide layout — see SlideViewer/CourseTime.page.jsx)
  onNextSlide,
  isNextButtonDisabled,
  onPrevSlide,
  isPrevButtonDisabled
}) => {
  if (!slide) return null;

  // activities templates — thin pass-throughs, kept inline
  switch (slide.SlideLayout) {
    case 'JOURNALING_SELF_REFLECTION_ACTIVITY':
      return (
        <JournalingActivity
          slide={slide}
          journalingText={journalingText}
          setJournalingText={setJournalingText}
          onSave={onJournalingSave}
          onEditActivity={onEditActivity}
          interactionLoading={interactionLoading}
          fetchingExistingRecord={fetchingExistingRecord}
          inputsDisabled={inputsDisabled}
          activityCompleted={activityCompleted}
          themeColor={themeColor}
          pageLc={pageLc}
        />
      );

    case 'SHARE_WORK_FILE_ACTIVITY':
      return (
        <ShareWorkActivity
          slide={slide}
          shareWorkLink={shareWorkLink}
          setShareWorkLink={setShareWorkLink}
          onSubmit={onShareWorkSubmit}
          onEditActivity={onEditActivity}
          interactionLoading={interactionLoading}
          fetchingExistingRecord={fetchingExistingRecord}
          inputsDisabled={inputsDisabled}
          activityCompleted={activityCompleted}
          themeColor={themeColor}
          pageLc={pageLc}
        />
      );

    case 'POLL_QUIZ_ACTIVITY':
      return (
        <PollActivity
          slide={slide}
          renderSpokenText={renderSpokenText}
          selectedPollOption={selectedPollOption}
          selectedPollOptions={selectedPollOptions}
          setSelectedPollOption={setSelectedPollOption}
          setSelectedPollOptions={setSelectedPollOptions}
          onSubmit={onPollSubmit}
          onEditActivity={onEditActivity}
          interactionLoading={interactionLoading}
          fetchingExistingRecord={fetchingExistingRecord}
          inputsDisabled={inputsDisabled}
          activityCompleted={activityCompleted}
          module_code={module_code}
          session={session}
          segment={segment}
          slideIndex={slideIndex}
          themeColor={themeColor}
          pageLc={pageLc}
        />
      );

    case 'DISCUSSION_ACTIVITY':
      return (
        <DiscussionActivity
          slide={slide}
          onDiscussionStart={onDiscussionStart}
          interactionLoading={interactionLoading}
          fetchingExistingRecord={fetchingExistingRecord}
          inputsDisabled={inputsDisabled}
          activityCompleted={activityCompleted}
          themeColor={themeColor}
          pageLc={pageLc}
        />
      );

    case 'ASSESSMENT_ACTIVITY':
      return (
        <AssessmentSlide
          slide={slide}
          renderSpokenText={renderSpokenText}
          // Activity props for assessment interactions
          activityCompleted={activityCompleted}
          interactionLoading={interactionLoading}
          fetchingExistingRecord={fetchingExistingRecord}
          inputsDisabled={inputsDisabled}
          onAssessmentSubmit={onAssessmentSubmit}
          onEditActivity={onEditActivity}
          assessmentAnswers={assessmentAnswers}
          setAssessmentAnswers={setAssessmentAnswers}
          questionNumber={questionNumber}
          totalQuestions={totalQuestions}
          pageLc={pageLc}
          onNextSlide={onNextSlide}
          isNextButtonDisabled={isNextButtonDisabled}
          onPrevSlide={onPrevSlide}
          isPrevButtonDisabled={isPrevButtonDisabled}
        />
      );

    default:
      break;
  }

  // Everything else: one layout component per SlideLayout (see slideRegistry.js)
  const LayoutComponent = slideRegistry[slide.SlideLayout] || DefaultFallbackSlide;

  return (
    <LayoutComponent
      slide={slide}
      collapsed={collapsed}
      renderSpokenText={renderSpokenText}
      skipTitleSpeech={skipTitleSpeech}
      assessmentScore={assessmentScore}
      assessmentResultLoading={assessmentResultLoading}
      themeColor={themeColor}
      pageLc={pageLc}
      onNextSlide={onNextSlide}
      isNextButtonDisabled={isNextButtonDisabled}
    />
  );
};

export default SlideRenderer;
